import { format, parse } from 'fecha';

export interface Config {
    dateFormat?: string;
}

export class SerializationUtils {
    private static Iso8601Regexp = /^(\d{4})-(\d{2})-(\d{2})T(\d{2})\:(\d{2})\:(\d{2})([+-](\d{2})\:(\d{2}))?$/;
    private static DateRegexp = /^(\d{4})-(\d{2})-(\d{2})$/;

    //#region ISerializationUtils

    public static serialize(value: any, params: Config = {}): any {
        if (!(value !== null && typeof value === 'object')) {
            return this.serilizePrimitivePropertyValue(value);
        }
        if (Array.isArray(value)) {
            return this.serializeArray(value);
        }
        if (value instanceof Date) {
            return this.serializeDate(value, params);
        }
        return Object.getOwnPropertyNames(value).reduce((result, key) => (result[key] = this.serialize(value[key], params), result), {} as Record<string, any>);
    }

    public static deserialize(value: any, params: Config = {}): any { // wymaga rozbudowania
        return JSON.parse(value, (_key, value) => {
            if (SerializationUtils.Iso8601Regexp.test(value) || SerializationUtils.DateRegexp.test(value)) {
                return this.deserializeDate(value, params);
            } else if (value instanceof Array) {
                return value;
            } else if (typeof value === 'string' && value.trim() !== '' && !isNaN(Number(value))) {
                return this.deserializeNumber(value);
            } else if (value === 'true' || value === 'false') {
                return value === 'true' ? true : false;
            }
            return value;
        });
    }

    //#endregion

    //#region Serialization

    private static serilizePrimitivePropertyValue(value: any): any {
        if (value === null || value === void 0) {
            return null;
        }

        if (typeof value === 'boolean') {
            return this.serializeBoolean(value);
        } else if (typeof value === 'number') {
            return this.serializeNumber(value);
        } else if (typeof value === 'string') {
            return this.serializeString(value);
        }
    }

    protected static serializeBoolean(value: boolean): any {
        return value;
    }

    protected static serializeNumber(value: number): any {
        return value;
    }

    protected static serializeString(value: string): any {
        return value;
    }

    protected static serializeDate(value: Date, params: Config = {}): any {
        return format(value, params.dateFormat || 'YYYY-MM-DDTHH:mm:ss');
    }

    protected static serializeArray(value: any[]): any[] {
        return value.map(v => this.serialize(v));
    }

    //#endregion

    //#region Deserialization

    protected static deserializeBoolean(value: boolean): any {
        return value;
    }

    protected static deserializeNumber(value: string): any {
        return +value;
    }

    protected static deserializeDate(value: any, params: Config = {}): Date | null {
        const dateFormat = params.dateFormat;
        if (!dateFormat) {
            const date = new Date(value);
            return isNaN(date.getTime()) ? null : date;
        }
        const parsedDate = parse(value, dateFormat);
        if (parsedDate instanceof Date) {
            return parsedDate;
        }
        return null;
    }

    //#endregion
}
